import { DeferredPromise } from "shared/utils/utils";


export class SequentialTasksExecutor {
  #counter = new SequentialTasksCounter();
  #tasks = [];
  #suspended = null;

  get isSuspended() { return !!this.#suspended; }

  add(task) {
    const toWait = [...this.#tasks];
    this.#suspended && toWait.push(this.#suspended.promise);

    const token = this.#counter.startTask();
    this.#tasks.push((async () => {
      await Promise.all(toWait);
      await task(token);
      this.#tasks.splice(0, 1);
    })());

    // There is a chance, that async function might not require context switching
    // and there is only one task so this.activePromises will be empty
    const count = this.#tasks.length;
    return count 
      ? this.#tasks[count - 1] 
      : (async () => {})(); // empty promise that will be immidiately fullfilled
  }

  addNoWait(task) {
    // TODO: @AM: do we need to take this.#suspended into an account?
    const token = this.#counter.startTask();
    const p = task(token);
    this.#tasks.push(p);
    // TODO: @AM: remove from activePromises
    p.then(() => this.#tasks.splice(this.#tasks.findIndex(x => x === p), 1));
    return p;
  }

  async waitForAll() {
    await Promise.all(this.#tasks);
  }

  suspend() {
    this.#suspended ??= new DeferredPromise();
  }

  resume() {
    this.#suspended?.resolve();
    this.#suspended = null;
  }

  getCurrentTaskToken() {
    return this.#counter.getCurrentTaskToken();
  }
}


export class NotActualTaskError extends Error {
  constructor(observed, expected) {
    super(`Task is not actual any more. Task: #${expected}, last task: #${observed}`);
  }
}


export class SequentialTasksCounter {
  constructor() {
    this.value = 0;
  }

  startTask() {
    ++this.value;
    if (this.value > 100_000_000) {
      this.value = 0;
    }
    return new TaskToken(this);
  }

  getCurrentTaskToken() {
    return new TaskToken(this)
  }
};


export class TaskToken {
  constructor(counter) {
    this.counter = counter;
    this.value = counter.value;
  }

  get isActual() {
    return this.value === this.counter.value;
  }

  throwIfNotActual() {
    if (!this.isActual) {
      throw new NotActualTaskError(this.counter.value, this.value); 
    }
  }
}


export default SequentialTasksExecutor;
